<template>
  <KeelearningContentCard
    v-if="shouldRenderKeelearningContentCard"
    :href="href"
    :morph-type="parsedURL.morphType"
    :foreign-id="parsedURL.foreignId"
    :user-ids="userIds">
    <slot />
  </KeelearningContentCard>
  <ExternalA
    v-else
    :href="href"
    :target="target">
    <slot />
  </ExternalA>
</template>

<script setup>
import { computed } from 'vue'

import ExternalA from '@/components/ExternalA.vue'
import KeelearningContentCard from '@/modules/chat/components/KeelearningContentCard.vue'
import { parseInternalLink } from '@/modules/chat/utils/parseInternalLink'

const props = defineProps({
  href: { type: String, required: true },
  target: { type: String, required: false, default: '_blank' },
  userIds: { type: Array, required: false, default: () => [] },
})

const parsedURL = computed(() => parseInternalLink(props.href))

const shouldRenderKeelearningContentCard = computed(() => !!(parsedURL.value && parsedURL.value.morphType && parsedURL.value.foreignId))
</script>
